import { render, staticRenderFns } from "./ProfileOverviewDashboard.vue?vue&type=template&id=d15d3de2&scoped=true"
import script from "./ProfileOverviewDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileOverviewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15d3de2",
  null
  
)

export default component.exports